import { z } from 'zod';
/** Learner bot admin contracts (M5): webhook, outbox monitor, support tickets. */
/** Telegram update: only `update_id` is checked here; the bot validates the rest. */
export const TelegramUpdate = z.looseObject({ update_id: z.number().int().nonnegative() });
export const OutboxQuery = z
    .object({
    status: z.enum(['queued', 'sending', 'sent', 'failed', 'dead']).optional(),
    limit: z.coerce.number().int().min(1).max(200).optional(),
})
    .strict();
export const TicketListQuery = z
    .object({
    status: z.enum(['open', 'answered', 'closed']).optional(),
    /** Queue filter, e.g. `grand_mock` for the SSC Rankers League support queue. */
    kind: z.enum(['support', 'paysupport', 'copyright', 'grand_mock']).optional(),
    limit: z.coerce.number().int().min(1).max(200).optional(),
})
    .strict();
export const TicketReplyRequest = z
    .object({
    text: z.string().trim().min(1).max(3000),
    close: z.boolean().optional(),
})
    .strict();
export const BotStatusDto = z.object({
    configured: z.boolean(),
    webhook: z
        .object({
        url: z.string(),
        pendingUpdates: z.number(),
        lastErrorAt: z.string().nullable(),
        lastError: z.string().nullable(),
    })
        .nullable(),
    webhookError: z.string().nullable(),
    inbox: z.record(z.string(), z.number()),
    outbox: z.record(z.string(), z.number()),
    openTickets: z.record(z.string(), z.number()),
});
export const SetWebhookDto = z.object({ url: z.string(), commands: z.number() });
export const OutboxMessageDto = z.object({
    id: z.string(),
    chatId: z.string(),
    method: z.string(),
    status: z.string(),
    attempts: z.number(),
    error: z.string().nullable(),
    createdAt: z.string(),
    sentAt: z.string().nullable(),
});
export const OutboxListDto = z.object({ messages: z.array(OutboxMessageDto) });
export const TicketDto = z.object({
    id: z.string(),
    productId: z.string(),
    userId: z.string(),
    kind: z.string(),
    orderRef: z.string().nullable(),
    status: z.string(),
    messages: z.array(z.object({ from: z.string(), text: z.string(), at: z.string() })),
    createdAt: z.string(),
    updatedAt: z.string(),
});
export const TicketListDto = z.object({ tickets: z.array(TicketDto) });
//# sourceMappingURL=telegram.js.map